/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/overview/mediaCarouselUI.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/overview/mediaCarouselUI', exports: {} };
const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from '@take-2/fd-modules/splits/require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import $ from '@take-2/fd-modules/jQuery';



import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { fd_url_manager as link } from '@take-2/fd-modules/splits/require-core';



import { Splide as Splide } from '@take-2/fd-modules/splits/require-core';



import { swig as swig } from '@take-2/fd-modules/splits/require-core';



import { Fandango_xhr as xhr } from '@take-2/fd-modules/splits/require-core';



import movie_shared_iconicImgUI_updateIconicImg from '@take-2/fd-modules/movie/shared/iconicImgUI';

const { updateIconicImg } = movie_shared_iconicImgUI_updateIconicImg;


const Selectors = {
    DEFAULT_ICONIC_IMG: '#mop-iconic-img-default',
    DEFAULT_ICONIC_IMG_BACKGROUND: '#mop-iconic-img-default-background',
    GALLERY: '#movie-detail-dropdown-media-gallery',
    SPLIDE_CAROUSEL: 'movie-detail-media-gallery', // ID PREFIX
    IMG_BTNS: '.js-gallery-img-btn',
}
function onOpenClick() {
    const index = this.dataset.imageIndex;
    debugLog.info(module.name, 'img click', index);
    track({
        event: EventTypes.PHOTO_CLICKS
    });
}
function onFetchDone(data) {
    const viewModel = {
        id: Selectors.SPLIDE_CAROUSEL,
        content: swig.render('_mediaGalleryItems', {
            ...data,
            moviePhotosURI: link.moviePhotosPosters({
                id: data.movieInfo.id,
                title: data.movieInfo.sluggedTitle
            })
        }),
    };
    document.querySelector(Selectors.GALLERY).innerHTML = swig.render('_splideCarousel', viewModel);
    updateIconicImg(data, 500);
    $(Selectors.IMG_BTNS).on('click', onOpenClick);
    new Splide(`#${Selectors.SPLIDE_CAROUSEL}-wrap`, {
        fixedWidth: '127px',
        fixedHeight: '120px',
        slideFocus: false,
        pagination: false,
    }).mount();
}
function onFetchFail(data) {
    debugLog.error(module.name, 'fetch failed', data);
    $(Selectors.GALLERY).remove();
}
function attach(movieID) {
    if (!document.querySelector(Selectors.GALLERY)) {
        return debugLog.warn(module.name, 'gallery missing', Selectors.GALLERY);
    }
    xhr.ajax({
        method: 'GET',
        url: link.napiMovieCarousel({ id: movieID }),
    })
        .done(onFetchDone)
        .fail(onFetchFail);
}
export default {
    attach
};
